import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {WebsiteEntityLinkContainerModel} from '../../../../../../models';

@Injectable({providedIn: 'root'})

export class WebsiteEntityMultipleLinkService extends BaseApiTemplateService<WebsiteEntityLinkContainerModel []> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-entity-links/multi';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-entity-links/multi';
    this.httpClient = http;
  }
}
